function housePriceCalculatorAlogrithm(
  homePrice,
  firstHome,
  builders,
  agency,
  revenue,
  lend
) {
  // Helper function to parse amount strings

  // Convert inputs
  const homePriceNum = homePrice;
  const revenueNum = revenue;
  const lendNum = lend;
  const isFirstHome = firstHome === "Y";
  const isBuilders = builders === "Y";
  const isAgency = agency === "Y";

  let impostaRegistro = 0;
  let valoreCatastale = 0;
  let iva = 0;

  let impostaCatastale = 50;
  let impostaIpotecaria = 50;

  let parcellaNotaio = 2220;

  let impostaSostitutiva = 0;

  // Calcolo valore catastale se la rendita è fornita
  if (revenueNum > 0) {
    valoreCatastale = isFirstHome ? revenueNum * 115.5 : revenueNum * 126;
  }

  // Calcolo imposta di registro
  if (!isBuilders) {
    // Acquisto da privato
    if (revenueNum > 0) {
      impostaRegistro = isFirstHome
        ? valoreCatastale * 0.02
        : valoreCatastale * 0.09;
    }
  } else {
    //IVA se Acquisti da Impresa, 4% come prima casa e 10% come seconda etc...
    if (!isFirstHome) {
      iva = homePriceNum * 0.1;
      impostaSostitutiva = lendNum * 0.02;
    } else {
      iva = homePriceNum * 0.04;
      impostaSostitutiva = lendNum * 0.0025;
    }

    // Acquisto da impresa
    impostaRegistro = 200;

    impostaCatastale = 200;
    impostaIpotecaria = 200;
  }

  // Calcolo costi agenzia (se applicabile)
  const costoAgenzia = isAgency
    ? homePriceNum * 0.034 + homePriceNum * 0.034 * 0.22
    : 0;

  // Calcolo altri costi (ipotetici, se richiesto estensione)
  const istruttoriaMutuo = 250;
  const periziaImmobile = 200;
  const parcellaNotaioMutuo = lendNum * 0.017;

  const costiMutuo =
    lendNum > 0
      ? istruttoriaMutuo +
        periziaImmobile +
        impostaSostitutiva +
        parcellaNotaioMutuo
      : 0;

  // Totale costi di acquisto
  const speseTotali =
    impostaRegistro +
    costoAgenzia +
    costiMutuo +
    iva +
    impostaIpotecaria +
    impostaCatastale +
    parcellaNotaio;

  return {
    impostaRegistro,
    costoAgenzia,
    speseTotali,
    impostaIpotecaria,
    impostaCatastale,
    parcellaNotaio,
    iva,
    lendNum,
    istruttoriaMutuo,
    periziaImmobile,
    impostaSostitutiva,
    parcellaNotaioMutuo,
    homePriceNum,
  };
}

export default housePriceCalculatorAlogrithm;
